"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALLET_EXPORT_TRUNCATION_NOTICE = exports.WALLET_EXPORT_MAX_ROWS = void 0;
exports.WALLET_EXPORT_MAX_ROWS = 5000;
exports.WALLET_EXPORT_TRUNCATION_NOTICE = `Export limited to the ${exports.WALLET_EXPORT_MAX_ROWS.toLocaleString("en-US")} most recent transactions. Choose a shorter timeline or date range for a complete export.`;
